import React from 'react';
import { SearchableFacetedFilter } from '@scentregroup/shared/hub-components/searchable-faceted-filter';
import trackClickEvent from '../../helpers/analytics-utils/track-event';
import { categories, actions } from '../../helpers/analytics-utils/constants';
import styles from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const WhatsHappeningMultiFilter = _ref => {
  let {
    filterOptions,
    selectedOptions,
    onSelectionChange
  } = _ref;
  const sanitizedFilterOptions = (filterOptions || []).filter(Boolean);
  if (sanitizedFilterOptions.length === 0) {
    return null;
  }
  const toggle = (selectedOptions, _ref2) => {
    let {
      option,
      isChecked
    } = _ref2;
    trackClickEvent(categories.WHATS_HAPPENING_FILTERS, isChecked ? actions.FILTER_SELECT : actions.FILTER_DESELECT, option);
    onSelectionChange(selectedOptions);
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.multiFilters,
    "data-id": "whats-happening-multi-filter-v2_index_WhatsHappeningMultiFilter_div",
    children: /*#__PURE__*/_jsx(SearchableFacetedFilter, {
      id: "WhatsHappeningMultiFilter",
      title: "WhatsHappeningMultiFilter",
      optionGroups: [{
        options: sanitizedFilterOptions.map(label => ({
          label,
          value: label
        }))
      }],
      selectedOptions: selectedOptions,
      onChange: toggle,
      "data-id": "whats-happening-multi-filter-v2_index_WhatsHappeningMultiFilter_div_SearchableFacetedFilter"
    })
  });
};
export default WhatsHappeningMultiFilter;